import React, { useState } from 'react';
import './FranchiseForm.css';

const FranchiseForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    contact: '',
    email: '',
    location: '',
    occupation: '',
    experience: '',
    autoExperience: '',
    expDetails: '',
    budget: '',
    investmentMode: [],
    franchiseCity: '',
    ownProperty: '',
    propertyDetails: '',
    interest: '',
    timeline: '',
    expectations: '',
    consent: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox' && name === 'investmentMode') {
      setFormData(prev => ({
        ...prev,
        investmentMode: checked 
          ? [...prev.investmentMode, value]
          : prev.investmentMode.filter(item => item !== value)
      }));
    } else if (type === 'checkbox') {
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Replace with your Google Form URL and field IDs
    const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/YOUR_FORM_ID/formResponse';
    
    const formDataToSubmit = new FormData();
    formDataToSubmit.append('entry.YOUR_NAME_FIELD_ID', formData.fullName);
    formDataToSubmit.append('entry.YOUR_CONTACT_FIELD_ID', formData.contact);
    formDataToSubmit.append('entry.YOUR_EMAIL_FIELD_ID', formData.email);
    formDataToSubmit.append('entry.YOUR_LOCATION_FIELD_ID', formData.location);
    formDataToSubmit.append('entry.YOUR_OCCUPATION_FIELD_ID', formData.occupation);
    formDataToSubmit.append('entry.YOUR_EXPERIENCE_FIELD_ID', formData.experience);
    formDataToSubmit.append('entry.YOUR_AUTO_EXP_FIELD_ID', formData.autoExperience);
    formDataToSubmit.append('entry.YOUR_EXP_DETAILS_FIELD_ID', formData.expDetails);
    formDataToSubmit.append('entry.YOUR_BUDGET_FIELD_ID', formData.budget);
    formDataToSubmit.append('entry.YOUR_INVESTMENT_MODE_FIELD_ID', formData.investmentMode.join(', '));
    formDataToSubmit.append('entry.YOUR_FRANCHISE_CITY_FIELD_ID', formData.franchiseCity);
    formDataToSubmit.append('entry.YOUR_OWN_PROPERTY_FIELD_ID', formData.ownProperty);
    formDataToSubmit.append('entry.YOUR_PROPERTY_DETAILS_FIELD_ID', formData.propertyDetails);
    formDataToSubmit.append('entry.YOUR_INTEREST_FIELD_ID', formData.interest);
    formDataToSubmit.append('entry.YOUR_TIMELINE_FIELD_ID', formData.timeline);
    formDataToSubmit.append('entry.YOUR_EXPECTATIONS_FIELD_ID', formData.expectations);
    
    try {
      await fetch(GOOGLE_FORM_URL, {
        method: 'POST',
        body: formDataToSubmit,
        mode: 'no-cors'
      });
      alert('Form submitted successfully! We will contact you soon.');
      onClose();
    } catch (error) {
      alert('There was an error submitting the form. Please try again.');
    }
  };

  return (
    <div className="franchise-form-overlay" onClick={onClose}>
      <div className="franchise-form-container" onClick={(e) => e.stopPropagation()}>
        <div className="franchise-form-header">
          <div className="logo">
            <img src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png" alt="VahaanBazar" />
          </div>
          <p>Franchise Application Form</p>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        
        <div className="franchise-form-content">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Full Name *</label>
              <input type="text" name="fullName" value={formData.fullName} onChange={handleInputChange} required />
            </div>
            
            <div className="form-group">
              <label>Contact Number *</label>
              <input type="tel" name="contact" value={formData.contact} onChange={handleInputChange} required />
            </div>
            
            <div className="form-group">
              <label>Email Address *</label>
              <input type="email" name="email" value={formData.email} onChange={handleInputChange} required />
            </div>
            
            <div className="form-group">
              <label>Current City & State *</label>
              <input type="text" name="location" value={formData.location} onChange={handleInputChange} required />
            </div>
            
            <div className="form-group">
              <label>Current Occupation / Business</label>
              <input type="text" name="occupation" value={formData.occupation} onChange={handleInputChange} />
            </div>
            
            <div className="form-group">
              <label>Years of Experience in Business/Industry</label>
              <input type="number" name="experience" value={formData.experience} onChange={handleInputChange} min="0" />
            </div>
            
            <div className="form-group">
              <label>Previous Experience in Automobile / Retail</label>
              <div className="radio-group">
                <div className={`radio-item ${formData.autoExperience === 'yes' ? 'checked' : ''}`} onClick={() => setFormData(prev => ({ ...prev, autoExperience: 'yes' }))}>
                  <input type="radio" name="autoExperience" value="yes" checked={formData.autoExperience === 'yes'} onChange={() => {}} />
                  <label>Yes</label>
                </div>
                <div className={`radio-item ${formData.autoExperience === 'no' ? 'checked' : ''}`} onClick={() => setFormData(prev => ({ ...prev, autoExperience: 'no' }))}>
                  <input type="radio" name="autoExperience" value="no" checked={formData.autoExperience === 'no'} onChange={() => {}} />
                  <label>No</label>
                </div>
              </div>
            </div>
            
            <div className="form-group">
              <label>If Yes, brief details</label>
              <textarea name="expDetails" value={formData.expDetails} onChange={handleInputChange} rows="3"></textarea>
            </div>
            
            <div className="form-group">
              <label>Available Investment Budget *</label>
              <div className="checkbox-group">
                {['5-10 Lakh', '10-20 Lakh', '20-50 Lakh', 'Above 50 Lakh'].map(budget => (
                  <div key={budget} className={`checkbox-item ${formData.budget === budget ? 'checked' : ''}`} onClick={() => setFormData(prev => ({ ...prev, budget }))}>
                    <input type="radio" name="budget" value={budget} checked={formData.budget === budget} onChange={() => {}} required />
                    <label>{budget}</label>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="form-group">
              <label>Preferred Mode of Investment</label>
              <div className="checkbox-group">
                {['Self-funded', 'Loan', 'Partnership'].map(mode => (
                  <div key={mode} className={`checkbox-item ${formData.investmentMode.includes(mode) ? 'checked' : ''}`} onClick={() => {
                    const isChecked = formData.investmentMode.includes(mode);
                    setFormData(prev => ({
                      ...prev,
                      investmentMode: isChecked 
                        ? prev.investmentMode.filter(item => item !== mode)
                        : [...prev.investmentMode, mode]
                    }));
                  }}>
                    <input type="checkbox" name="investmentMode" value={mode} checked={formData.investmentMode.includes(mode)} onChange={() => {}} />
                    <label>{mode}</label>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="form-group">
              <label>City / Area Interested for Franchise *</label>
              <input type="text" name="franchiseCity" value={formData.franchiseCity} onChange={handleInputChange} required />
            </div>
            
            <div className="form-group">
              <label>Do you own commercial property suitable for franchise?</label>
              <div className="radio-group">
                <div className={`radio-item ${formData.ownProperty === 'yes' ? 'checked' : ''}`} onClick={() => setFormData(prev => ({ ...prev, ownProperty: 'yes' }))}>
                  <input type="radio" name="ownProperty" value="yes" checked={formData.ownProperty === 'yes'} onChange={() => {}} />
                  <label>Yes</label>
                </div>
                <div className={`radio-item ${formData.ownProperty === 'no' ? 'checked' : ''}`} onClick={() => setFormData(prev => ({ ...prev, ownProperty: 'no' }))}>
                  <input type="radio" name="ownProperty" value="no" checked={formData.ownProperty === 'no'} onChange={() => {}} />
                  <label>No</label>
                </div>
              </div>
            </div>
            
            <div className="form-group">
              <label>If Yes, mention details (Size, Location, Ownership/Lease status)</label>
              <textarea name="propertyDetails" value={formData.propertyDetails} onChange={handleInputChange} rows="3"></textarea>
            </div>
            
            <div className="form-group">
              <label>Why are you interested in Vahaan Bazar Franchise?</label>
              <textarea name="interest" value={formData.interest} onChange={handleInputChange} rows="4"></textarea>
            </div>
            
            <div className="form-group">
              <label>Expected Timeline to Start</label>
              <div className="checkbox-group">
                {['Immediate', '1-3 months', '3-6 months', 'Later'].map(time => (
                  <div key={time} className={`checkbox-item ${formData.timeline === time ? 'checked' : ''}`} onClick={() => setFormData(prev => ({ ...prev, timeline: time }))}>
                    <input type="radio" name="timeline" value={time} checked={formData.timeline === time} onChange={() => {}} />
                    <label>{time}</label>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="form-group">
              <label>Any other expectations / notes</label>
              <textarea name="expectations" value={formData.expectations} onChange={handleInputChange} rows="3"></textarea>
            </div>
            
            <div className="consent-box">
              <label>
                <input type="checkbox" name="consent" checked={formData.consent} onChange={handleInputChange} required />
                I confirm that the information provided above is true to the best of my knowledge and authorize Vahaan Bazar team to contact me for franchise discussion
              </label>
            </div>
            
            <button type="submit" className="submit-btn">Submit Application</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FranchiseForm;